var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';

var BotonSiguiente = function BotonSiguiente(_ref) {
  var activo = _ref.activo,
      onClick = _ref.onClick;
  var eventos = activo ? {
    onClick: onClick
  } : {};
  return React.createElement('div', _extends({
    className: 'siguienteImagenVisorImagenes' + (activo ? '' : ' desactivado')
  }, eventos));
};

BotonSiguiente.propTypes = process.env.NODE_ENV !== "production" ? {
  activo: t.bool,
  onClick: t.func
} : {};
export default BotonSiguiente;